import { render, staticRenderFns } from "./chatbot-button.vue?vue&type=template&id=12665cfa"
import script from "./chatbot-button.vue?vue&type=script&lang=js"
export * from "./chatbot-button.vue?vue&type=script&lang=js"
import style0 from "./chatbot-button.vue?vue&type=style&index=0&id=12665cfa&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports